// Sheep animal soft-delete and restore API.
// Both operations use transactional SECDEF RPCs that mutate
// the record and insert an Activity event in one transaction.

import type {RpcEnvelope, SupabaseClient} from './supabaseTypes.js';

export async function softDeleteSheepAnimal(
  sb: SupabaseClient,
  id: string,
  label?: string | null,
): Promise<RpcEnvelope> {
  if (!sb) throw new Error('softDeleteSheepAnimal: sb required');
  const {data, error} = await sb.rpc('soft_delete_sheep_animal', {
    p_entity_id: id,
    p_entity_label: label || null,
  });
  if (error) throw new Error(`softDeleteSheepAnimal: ${error.message || String(error)}`);
  return data;
}

export async function restoreSheepAnimal(sb: SupabaseClient, id: string, label?: string | null): Promise<RpcEnvelope> {
  if (!sb) throw new Error('restoreSheepAnimal: sb required');
  const {data, error} = await sb.rpc('restore_sheep_animal', {
    p_entity_id: id,
    p_entity_label: label || null,
  });
  if (error) throw new Error(`restoreSheepAnimal: ${error.message || String(error)}`);
  return data;
}
